<template>
<div class="container">
 <termsConditions></termsConditions>

</div>
</template>

<script>
import termsConditions from '../components/chaldal/Terms_Conditions.vue';


export default {
components:{
  termsConditions
},


 created() { this.Loaded();
  }
}
</script>

<style scoped>

</style>